import { render, staticRenderFns } from "./TextRecommendationEmpty.vue?vue&type=template&id=6db9a84f&scoped=true"
import script from "./TextRecommendationEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationEmpty.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationEmpty.vue?vue&type=style&index=0&id=6db9a84f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9a84f",
  null
  
)

export default component.exports